import { FC } from 'react';
import { AdminCardVouchersList } from 'containers/admin';
import { AdminCardLayout } from 'pages/atoms';

const AdminCardVouchersPage: FC = () => {
  return (
    <AdminCardLayout>
      <AdminCardVouchersList />
    </AdminCardLayout>
  );
};

export default AdminCardVouchersPage;
